/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Duration_Out_Of_Bounds_HintInputs */



/**
* | output |
* | --- |
* | "Increase/decrease the duration of the Event." |
*
* @param {Error_Nav_Duration_Out_Of_Bounds_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_duration_out_of_bounds_hint = /** @type {((inputs?: Error_Nav_Duration_Out_Of_Bounds_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Duration_Out_Of_Bounds_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Augmentez/reduisez la duree de l'evenement.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Dauer des Ereignisses erhöhen/verkürzen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aumenta/diminuisci la durata dell'evento.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Увеличить/уменьшить продолжительность мероприятия.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aumentar/disminuir la duración del Evento.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("增加/减少事件持续时间。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントの継続時間を増加/減少します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट की अवधि बढ़ाएँ/घटाएँ।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aumentar/diminuir a duração do evento.")
	return /** @type {LocalizedString} */ ("Increase/decrease the duration of the Event.")
});